'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mechvent = require('./mechvent.html');

var _mechvent2 = _interopRequireDefault(_mechvent);

var _mechvent3 = require('./mechvent.controller');

var _mechvent4 = _interopRequireDefault(_mechvent3);

require('./mechvent.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mechventComponent = {
  restrict: 'E',
  bindings: {},
  template: _mechvent2.default,
  controller: _mechvent4.default,
  controllerAs: 'vm'
};

exports.default = mechventComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/mechvent/mechvent.component.js